<template>
  <footer class="footer">
    <div class="container-fluid">
      <nav class="pull-left">
        <ul>
          <li>
            <a target="_blank" href="http://exentis.pl">
              Exentis - v.{{vueVersion}}
            </a>
          </li>
        </ul>
      </nav>
      <div class="copyright pull-right">
        &copy; Coded by
        <a href="http://exentis.pl" target="_blank" rel="noopener">Exentis </a>.
<!--        <span>Designed by <a href="https://www.creative-tim.com/?ref=pdf-vuejs" rel="noopener" target="_blank">Creative Tim</a>.</span>-->
      </div>
    </div>
  </footer>
</template>
<script>
import { version } from '../../../../package.json'
export default {
  computed: {
    vueVersion: function () {
      return version
    }
  }
}

</script>
<style>

</style>
